import script from "./SectionAGeneral.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionAGeneral.vue?vue&type=script&setup=true&lang=js"

import "./SectionAGeneral.vue?vue&type=style&index=0&id=4934466d&lang=css"

const __exports__ = script;

export default __exports__